<template>
  <v-card class="colorDominant mt-2">
    <v-progress-linear absolute indeterminate :active="loading" class="px-8">
    </v-progress-linear>

    <v-expansion-panels
      v-if="data.length > 0"
      v-model="panel"
      multiple
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <v-expansion-panel
        v-for="(bet, i) in data"
        :key="`${i}${bet.id}`"
        v-model="bet.open"
      >
        <v-expansion-panel-header color="colorDominant" class="px-5">
          <div class="d-flex">
            <div class="font-weight-bold subtitle-2 white--text">
              {{ bet.title }} {{ $t("labelCurrency") }} {{ bet.amount }}
            </div>
            <div class="font-weight-bold subtitle-2 ml-1 white--text">
              {{ typeBet(bet.n_events) }}
            </div>
            <div class="mt-1 ml-1">
              <v-icon
                small
                :color="betStatus(bet.result_bet, bet.status_bet).color"
                >{{ betStatus(bet.result_bet, bet.status_bet).icon }}</v-icon
              >
              <v-icon
                small
                color="blue"
                :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : 'ml-2'"
                v-if="bet.debita_saldo == '3' && $vuetify.breakpoint.smAndDown"
              >
                mdi-gift-open
              </v-icon>
            </div>
            <v-chip
              class="font-weight-black ml-2 mt-2"
              x-small
              color="blue"
              v-if="bet.debita_saldo == '3' && !$vuetify.breakpoint.smAndDown"
            >
              {{ $t("chipIsBonus") }}
            </v-chip>
            <span
              v-show="bet.cashOutValue && $isCreditOnline()"
              style="font-size: 24px"
              class="primary--text pl-1"
              >•
            </span>
          </div>
          <div
            class="caption text-right grey--text"
            :class="$vuetify.breakpoint.smAndDown ? 'mr-1' : 'mr-3 '"
          >
            Nº {{ bet.id }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content color=" colorDominant">
          <v-divider></v-divider>
          <template>
            <div v-for="(event, index) in bet.events" :key="index">
              <div class="d-flex mb-2">
                <!-- ======================== -->
                <!-- Ícone de Status da Lista -->
                <!-- ======================== -->
                <div class="d-flex pr-4">
                  <v-icon
                    small
                    :color="
                      eventStatus(event.result_event, event.status_event).color
                    "
                  >
                    {{
                      eventStatus(event.result_event, event.status_event).icon
                    }}
                  </v-icon>
                </div>

                <!-- ======================== -->
                <!-- Dados dos Eventos        -->
                <!-- ======================== -->
                <div class="flex-grow-1">
                  <div>
                    <div class="mt-4">
                      <div>
                        <!-- Título Evento -->
                        <div
                          v-if="$route.name != 'resolvedBets'"
                          class="cursor-pointer flex-grow-1"
                          @click="
                            routerPush(
                              event.category_id,
                              event.tournaments_id,
                              event.id_event,
                              event.category_name,
                              event.tournaments_name,
                              event.description,
                              event.id_sport
                            )
                          "
                        >
                          <!-- Descrição do Evento (Time A x Time B) -->
                          <div class="subtitle-2 text-truncate">
                            <div class="d-flex align-center my-1">
                              <TeamLogo
                                :id_sport="event.id_sport"
                                :id_team="event.id_team_1"
                                :type_size="'medium_logo'"
                                :size="'24px'"
                                class="mr-1"
                              />
                              {{ event.description.split(" X ")[0] }}
                            </div>
                            <div class="d-flex align-center my-1">
                              <TeamLogo
                                :id_sport="event.id_sport"
                                :id_team="event.id_team_2"
                                :type_size="'medium_logo'"
                                :size="'24px'"
                                class="mr-1"
                              />
                              {{ event.description.split(" X ")[1] }}
                            </div>
                          </div>
                          <!-- {{ event.description }} -->

                          <!-- Ícone de Live com Animação para caso de eventos em andamento -->
                          <!-- <v-icon
                            color="primary"
                            class="live-ani"
                            v-show="event.live_event == '1'"
                            >mdi-access-point</v-icon
                          > -->
                          <v-chip
                            v-show="event.live_event == '1'"
                            x-small
                            outlined
                            class="ml-1 pa-2 live-ani"
                            color="primary"
                            >live</v-chip
                          >
                        </div>
                        <!-- Descrição do Evento -->
                        <span v-else class="flex-grow-1">
                          {{ event.description }}
                        </span>
                      </div>
                    </div>
                    <div class="d-flex justify-space-between">
                      <div>
                        <div class="caption grey--text">
                          {{ event.category_name }} •
                          {{ event.tournaments_name }} •
                          {{ event.scheduled | formatDate() }}
                        </div>
                        <div class="caption">
                          {{ $infoTable.markets(event.id_market).name_market }}
                        </div>
                        <span class="subtitle-2 font-weight-bold">{{
                          $infoTable.outcomes(event.id_outcome).name_outcome
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ======================== -->
                <!-- Odd / Tracker -->
                <!-- ======================== -->
                <div
                  class="
                    mt-4
                    d-flex
                    flex-column
                    text-center
                    justify-space-between
                  "
                >
                  <!-- Odd -->
                  <div>{{ event.factor_event }}</div>

                  <!-- Tracker -->
                  <!-- Ícone de Live com Animação para caso de eventos em andamento -->
                  <div v-if="$permissions().statsCore">
                    <v-btn icon @click="openTracker(bet.id, event.id_event)">
                      <v-icon
                        :color="
                          idEvent == event.id_event && idBet == bet.id
                            ? 'primary'
                            : ''
                        "
                        >mdi-soccer-field</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
              </div>

              <div v-show="!disabledWidget && idEvent == event.id_event">
                <div style="background: rgba(0, 0, 0, 0.35)">
                  <div
                    style="max-width: 450px; margin: 0 auto"
                    :id="`widget-${bet.id}-${event.id_event}`"
                  ></div>
                </div>
              </div>

              <div
                v-if="
                  idEvent == event.id_event && idBet == bet.id && unavailable
                "
                class="pa-4 text-center caption"
                style="background-color: rgba(0, 0, 0, 0.35)"
              >
                {{ $t("unavailableTracker") }} 😞
              </div>
              <v-divider class="mb-4"></v-divider>
            </div>
          </template>
          <!-- <v-divider class="my-3"></v-divider> -->

          <template>
            <v-row class="text-center px-0 caption">
              <v-col>
                <div class="grey--text">
                  {{ $t("value").toUpperCase() }}
                </div>
                <div>{{ $t("labelCurrency") }}{{ bet.amount }}</div>
              </v-col>
              <v-col>
                <div class="grey--text">ODDS</div>
                <div>
                  {{ bet.factor_bet }}
                </div>
              </v-col>
              <v-col>
                <div class="grey--text">
                  {{ $t("return").toUpperCase() }}
                </div>
                <div>{{ $t("labelCurrency") }}{{ bet.prize }}</div>
              </v-col>
              <v-col
                v-if="
                  $vuetify.breakpoint.lgAndUp &&
                  ($route.name == 'closeBets' || $route.name == 'liveBets') &&
                  operatorCashout == '1' &&
                  $isCreditOnline()
                "
              >
                <v-btn
                  class="px-2"
                  color="primary"
                  @click="cashOutBet(bet.id, bet.cashOutValue, i)"
                  :loading="loadingCashOut"
                  :disabled="
                    loadingCashOut || !bet.cashOutValue || bet.cashOuted
                  "
                  block
                  v-if="!bet.cashOuted"
                >
                  <template>
                    {{ $t("cashOut") }}
                    <div class="font-weight-bold ml-4">
                      <span v-if="bet.cashOutValue">
                        {{ $t("labelCurrency") }} </span
                      >{{ bet.cashOutValue }}
                    </div>
                  </template>
                </v-btn>
                <v-icon size="30" color="teal" class="mt-2" v-else>
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-col>
            </v-row>
            <template
              v-if="
                $vuetify.breakpoint.mdAndDown &&
                ($route.name == 'closeBets' || $route.name == 'liveBets') &&
                operatorCashout == '1' &&
                $isCreditOnline()
              "
            >
              <v-btn
                class="mt-5 px-2"
                color="primary"
                block
                @click="cashOutBet(bet.id, bet.cashOutValue, i)"
                :loading="loadingCashOut"
                :disabled="loadingCashOut || !bet.cashOutValue"
                v-if="!bet.cashOuted"
              >
                {{ $t("cashOut") }}
                <div class="font-weight-bold ml-2">
                  <span v-if="bet.cashOutValue">
                    {{ $t("labelCurrency") }}
                  </span>
                  {{ bet.cashOutValue }}
                </div>
              </v-btn>
              <div class="text-center" v-else>
                <v-icon size="20" color="teal" class="mt-3">
                  mdi-checkbox-marked-circle
                </v-icon>
              </div>
            </template>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <div class="subtitle px-3 pt-5 pb-2">
        <div class="text-center primary--text pb-2" text-center v-if="loading">
          {{ $t("loading") }}
        </div>
        <v-alert v-else text dense type="warning" border="left">{{
          $t("noBetsFound")
        }}</v-alert>
      </div>
    </div>
  </v-card>
</template>
<script>
var widget = "";
import TeamLogo from "@/components/team-logo";
export default {
  props: ["data", "loading"],
  components: {
    TeamLogo,
  },
  data: () => ({
    loadingCashOut: false,
    panel: [0],
    // Statscores
    disabledWidget: false,
    idBet: "",
    idEvent: "",
    unavailable: false,
  }),
  async beforeDestroy() {
    if (this.$permissions().statsCore) {
      if (widget != "") {
        await widget.destroy();
      }
    }
  },
  computed: {
    // Retrieve Sports by InfoTable;
    sportsByInfoTable() {
      return this.$store.state.sports;
    },
    // status logged
    logged() {
      return this.$store.state.logged.status;
    },
    // Operator Cashout
    operatorCashout() {
      return this.$store.state.operators.cashout;
    },
  },
  methods: {
    // CashOut Bet
    cashOutBet(betId, cashOutvalue, index) {
      if (!this.logged) return;
      this.loadingCashOut = true;
      this.$axios
        .post(
          "/player/online/betsOnline/cashout",
          this.$formdata({
            id_bet: betId,
            value: cashOutvalue,
          })
        )
        .then(async (resp) => {
          // Informando que o cashOut foi realizado
          this.data[index].cashOuted = true;
          // Mensagem de sucesso
          const msg = await resp.data.messages;
          const color = "green";
          this.$store.commit("setNotification", { msg, color });
          // Atualizando o icon do resultado do evento UI
          this.data[index].result_bet = "2";
          this.data[index].result_event = "2";
          this.data[index].open = false;
          this.data[index].events.forEach((event) => {
            // Atualizando o resultado do evento UI
            if (event.result_event == "") {
              event.result_event = "2";
            }
          });
          this.$store.commit("setCash", resp.data.balance);
          return index;
        })
        .then((index) => {
          // Ataulizando o array removendo o item que foi feito o cashout
          var _this = this;
          setTimeout(function () {
            _this.panel = undefined;
            _this.data.splice(index, 1);
          }, 5000);
        })
        .catch((error) => {
          let msg;
          // Tratamento para quando o valor da ODD está desatualizado
          if (error.response.status == 403) {
            msg = error.response.data.messages.messages;
            let newValueCashOut =
              error.response.data.messages.dados.value_cashout;
            // Atualizando o valor da ODD
            this.data[index].cashOutValue = newValueCashOut;
          } else {
            msg = error.response.data.messages.error;
          }
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => {
          this.loadingCashOut = false;
        });
    },

    // Push Route Event
    routerPush(
      categoryId,
      tournamentId,
      eventId,
      categoryName,
      tournamentName,
      eventDescription,
      sportId
    ) {
      const sport = this.sportsByInfoTable.find((sport) => {
        if (sport.id_sport == sportId) {
          return sport;
        }
      });
      this.$router.push({
        name: "btEvent",
        params: {
          sport: sportId,
          category: categoryId,
          tournament: tournamentId,
          event: eventId,
        },
        query: {
          sport: sport.name_sport,
          category: categoryName,
          tournament: tournamentName,
          event: eventDescription,
          mobile: this.$vuetify.breakpoint.smAndDown,
          liveEvent: this.$route.name == "liveBets" ? true : false,
        },
        hash: "#scrollTop",
      });
    },

    // Tipo de apostas UI
    typeBet: function (val) {
      const type = {
        1: this.$t("simple"),
        2: this.$t("double"),
        3: this.$t("triple"),
      };
      if (val >= 4) return this.$t("multiple");
      return type[val];
    },

    // Status de aposta UI
    eventStatus(result_event, status_event) {
      // Cancelado
      if (status_event == "0") {
        return {
          color: "purple",
          icon: "mdi-minus-circle",
        };
      }
      const statusEvent = {
        // Pendente
        "": {
          color: "grey",
          icon: "mdi-checkbox-blank-circle",
        },
        // Perdida
        0: {
          color: "red",
          icon: "mdi-close-circle",
        },
        1: {
          color: "green",
          icon: "mdi-checkbox-marked-circle",
        },
        2: {
          color: "#AFB42B",
          icon: "mdi-arrow-left-circle",
        },
      };
      return statusEvent[result_event];
    },

    // Status de aposta UI
    betStatus(result_bet, status_bet) {
      //Debugg
      // const result_bet = "";
      // const status_bet = "";
      // Cancelado
      if (status_bet == "0") {
        return {
          color: "purple",
          icon: "mdi-swap-vertical-circle",
        };
      }
      // Acertou
      if (result_bet == "1") {
        return {
          color: "green",
          icon: "mdi-checkbox-marked-circle",
        };
      }
      // // Cashout
      if (result_bet == "2") {
        return {
          color: "#AFB42B",
          icon: "mdi-arrow-left-circle",
        };
      }
      // Não acertou
      if (result_bet == "0") {
        return {
          color: "red",
          icon: "mdi-close-circle",
        };
      }
      // Pendente
      if (result_bet == "" || result_bet == null) {
        return {
          color: "grey",
          // icon: "mdi-checkbox-blank-circle",
        };
      }
    },

    // Open Live Match Pro (Statscore)
    openTracker(id_bet, id_event) {
      // Reset
      this.unavailable = false;

      // Se o tracker do mesmo id estiver aberto, apenas fecha;
      if (this.idBet == id_bet && this.idEvent == id_event) {
        this.closeTracker();
        this.disabledWidget = true;
        this.idBet = "";
        this.idEvent = "";
        return;
      }

      // Se já existe um tracker aberto, fecha o anterior
      if (this.idEvent != "") {
        this.closeTracker();
        this.unavailable = false;
        this.disabledWidget = true;
      }

      // https://statscore.atlassian.net/wiki/spaces/STW/pages/2917072899/Advanced
      var d = "STATSCOREWidgetsEmbederScript";
      if (!window.document.getElementById(d)) {
        (window.STATSCOREWidgets = {}),
          (window.STATSCOREWidgets.onLoadCallbacks = []),
          (window.STATSCOREWidgets.onLoad = function (d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          });
        var n = window.document.createElement("script");
        (n.src = "https://wgt-s3-cdn.statscore.com/bundle/Embeder.js"),
          (n.async = !0),
          (n.id = d),
          n.addEventListener("error", function (d) {
            for (
              var n = 0;
              n < window.STATSCOREWidgets.onLoadCallbacks.length;
              n++
            )
              window.STATSCOREWidgets.onLoadCallbacks[n](d);
          }),
          window.document.body.appendChild(n);
      }

      // Hook up when library is loaded and ready to use.
      // You can use this method as many times as necessary - if library
      // is already loaded provided callback will fire immediately
      STATSCOREWidgets.onLoad((err) => {
        if (err) {
          switch (err.type) {
            case "NetworkError":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
            case "BrowserNotSupported":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
          }
          return;
        } else {
          this.disabledWidget = false;
        }

        // Widget will be appended to this HTMLElement.
        //
        // If you are using framework then follow its documentation
        // on how to get DOM Element from your component.
        // Vue.js https://vuejs.org/v2/api/#ref
        // React https://en.reactjs.org/docs/refs-and-the-dom.html
        // Angular https://angular.io/api/core/ElementRef
        const idElement = `widget-${id_bet}-${id_event}`;
        const element = document.getElementById(idElement);
        // Configuration that you should receive from STATSCORE
        const configurationId = "62abb4d3d4bbb801868d7950";
        // Input data for widget type you want to embded
        const inputData = {
          eventId: `m:${id_event}`,
          language: "br",
        };
        const options = {};
        widget = new window.STATSCOREWidgets.WidgetGroup(
          element,
          configurationId,
          inputData,
          options
        );

        // Armazenando o id do evento aberto e id da bet;
        this.idEvent = id_event;
        this.idBet = id_bet;

        widget.on("error", async () => {
          await widget.destroy();
          this.disabledWidget = true;
          this.unavailable = true;
        });
      });
    },

    async closeTracker() {
      await widget.destroy();
    },
  },
  filters: {
    formatDate: (val) => {
      var date = new Date(val.replace(" ", "T")).toLocaleDateString("pt-BR", {
        month: "2-digit",
        day: "numeric",
      });
      var hour = new Date(val.replace(" ", "T")).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      return `${date} ${hour}`;
    },
  },
};
</script>
<style>
.zoom-in-out-box {
  /* margin: 24px;
  width: 50px;
  height: 50px;*/
  /* color: #fffff;  */
  /* border: 0.25px solid; */
  border-radius: 50%;
  animation: zoom-in-zoom-out ease;
  animation-duration: 4s;
}

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1);
  }
  10%,
  20% {
    transform: scale(1) rotate(-40deg);
  }
  30%,
  50% {
    transform: scale(1.4) rotate(25deg);
  }
  70%,
  90% {
    transform: scale(1) rotate(25deg);
  }
  40%,
  60%,
  80% {
    transform: scale(1.3) rotate(20deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
.w-100 {
  width: 100%;
}
</style>
